export const dates = (date: string | number | Date) => {
  const dateFull = new Date(date);

  const dateFormat = dateFull.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const weekday = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ];

  const day = weekday[dateFull.getDay()];
  const hourFull = `${String(dateFull.getHours()).padStart(2, "0")}h${String(
    dateFull.getMinutes()
  ).padStart(2, "0")}`;
  return { dateFormat: dateFormat, weekday: day, hour: hourFull };
};
